// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success_message-container{display:flex;padding:16px;border-radius:6px;background-color:var(--colors-palette-emerald-1);margin-bottom:24px}.success_message-container__icon{flex-shrink:0;margin:0 8px 0 0}.success_message-container__text{font-size:14px;line-height:20px;overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
